import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoneAll = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1506_101163",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1506_101163)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.06734 17.0211L1.92309 12.8769C1.77439 12.7282 1.701 12.5541 1.70292 12.3548C1.70483 12.1554 1.78336 11.9782 1.93849 11.8231C2.09361 11.6782 2.26924 11.6032 2.46539 11.5981C2.66154 11.5929 2.83718 11.6679 2.99232 11.8231L6.71539 15.5461L7.06159 15.2L8.11539 16.2538L7.33269 17.0211C7.15193 17.1916 6.94103 17.2794 6.70002 17.2846C6.459 17.2897 6.24811 17.2019 6.06734 17.0211ZM11.7173 17.0211L7.57312 12.8769C7.43465 12.7384 7.36382 12.5669 7.36062 12.3625C7.3574 12.158 7.42823 11.9782 7.57312 11.8231C7.72823 11.6679 7.90643 11.5904 8.10772 11.5904C8.30898 11.5904 8.48718 11.6679 8.64232 11.8231L12.35 15.5308L21.0231 6.85766C21.1718 6.70895 21.3458 6.63556 21.5452 6.63749C21.7446 6.63941 21.9218 6.71793 22.0769 6.87306C22.2218 7.02818 22.2968 7.20381 22.3019 7.39996C22.307 7.59611 22.2321 7.77175 22.0769 7.92686L12.9827 17.0211C12.8019 17.2019 12.591 17.2922 12.35 17.2922C12.109 17.2922 11.8981 17.2019 11.7173 17.0211ZM12.0038 12.35L10.9346 11.2961L15.3577 6.87306C15.4962 6.7346 15.6677 6.66376 15.8721 6.66056C16.0766 6.65735 16.2564 6.72818 16.4115 6.87306C16.5667 7.02818 16.6442 7.20638 16.6442 7.40766C16.6442 7.60893 16.5667 7.78713 16.4115 7.94226L12.0038 12.35Z",
			fill: "currentColor"
		})
	})]
});
export default SvgDoneAll;
